import { colors } from "@material-ui/core";

import { Button } from "@/design-system/components/Button/Button";
import { toast } from "@/design-system/components/Toast/Toast";

import { makeRequest } from "@/util";

import { YelpIcon } from "@/components/icons/themes/logos";
import { DestinationConfigRow } from "@/destinations/configs/shared/ConfigPageRow";

export function OAuthModal() {
  return null;
}

export function OAuthRow({ existingConfig, destination }) {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const onOpenConfigModal = () => {
    const request: {
      integration_name: string;
      destination_id?: string;
    } = {
      integration_name: destination.slug,
    };
    if (existingConfig?.id) {
      request.destination_id = existingConfig.id;
    }

    makeRequest("get_oauth_url", request)
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup " + destination.name + ".",
        );
      });
  };

  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#d32323]"
      leadingIcon={<YelpIcon className="h-4 w-4" />}
      onClick={onOpenConfigModal}
    >
      {oauthConfigured ? "Reconnect" : "Connect with Yelp"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
}

const OAUTH = "OAUTH";

const Rows = {
  [OAUTH]: OAuthRow,
};

const Modals = {
  [OAUTH]: OAuthModal,
};

const RowOrder = [OAUTH];

const config = {
  Rows,
  RowOrder,
  Modals,
};
export default config;
